<template>
  <div>
    <orders-component />
  </div>
</template>

<script>
import OrdersComponent from '@/components/OrdersComponent.vue';
export default {
  name: "OrdersPage",
  components: { OrdersComponent },
};
</script>

<style scoped>
</style>

